import { useSelector, useDispatch } from "react-redux";
import { clearVideoRecording, saveVideoRecording } from "../../../redux/WebSocketSlice";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";

const SaveVideoModal = () => {
    const dispatch = useDispatch();
    const pendingVideos = useSelector((state: any) => state.webSocket.pendingVideos);
    const intl = useIntl()

    const [show, setShow] = useState(false)

    useEffect(() => {
        if (pendingVideos && !_.isEmpty(pendingVideos)) {
            setShow(true)
        } else {
            setShow(false);
        }
    }, [pendingVideos])

    useEffect(() => {
        if (show === false) {
            dispatch(clearVideoRecording())
        }
    }, [show])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="save-video-modal">
            <Modal.Body>
                <div className='d-flex w-100 align-items-center justify-content-between'>
                    <h1 className='text-primary d-flex gap-3 align-items-center'>
                        {intl.formatMessage({ id: 'TOAST.DO_YOU_WANT_TO_SAVE_THE_RECORDED_VIDEO' })}
                    </h1>
                    <button className='btn btn-link p-0' type='button' onClick={handleClose}>
                        <i
                            className='fa fa-times-thin fa-2x'
                            aria-hidden='true'
                            style={{ fontSize: '2em', padding: 0, verticalAlign: 'unset' }}
                        ></i>
                    </button>
                </div>
                <div className='line-break w-100 mt-5 mb-10' style={{ backgroundColor: '#EFF2F5', height: 1 }} />
                <div className="row gap-12 mb-5">
                    {pendingVideos.map((cameraId: any) => (
                        <div className="" key={cameraId}>
                            <React.Fragment>
                                <div className='text-gray-700 fw-bold fs-3 d-flex align-items-center'>
                                    <span className='w-100'>
                                        {intl.formatMessage({ id: 'GENERAL.LABEL.RECORDED_VIDEO_OF' })} {cameraId}
                                    </span>
                                    {/* : {selectedDevice.TimeRange && <>{selectedDevice.TimeRange}</>} */}
                                    <div className='snapshot-image d-flex justify-content-center gap-5 w-100'>
                                        <button
                                            className='btn btn-primary btn-sm d-flex gap-1 align-items-center'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                dispatch(saveVideoRecording(cameraId))
                                            }}
                                        >
                                            <i className='bi bi-download' style={{ fontSize: '17px' }}></i>
                                            {intl.formatMessage({ id: "BUTTON.SAVE" })}
                                        </button>
                                        <button
                                            className='btn btn-primary btn-sm d-flex gap-1 align-items-center'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                dispatch(clearVideoRecording(cameraId))
                                            }}
                                        >
                                            <i className='bi bi-trash' style={{ fontSize: '17px' }}></i>
                                            {intl.formatMessage({ id: "BUTTON.DISCARD" })}
                                        </button>
                                    </div>
                                </div>
                            </React.Fragment>
                        </div>
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default SaveVideoModal;
